/*
 *
 * App actions
 *
 */

import {
  SET_AUTH_TOKEN,
  SET_USER,
  NOOP,
  SIGN_OUT,
  FETCH_SESSION,
  SESSION_LOAD_FAILED,
} from './constants';

export const setAuthToken = (payload) => ({
  type: SET_AUTH_TOKEN,
  payload,
});

export const setUser = (data) => ({
  type: SET_USER,
  payload: {
    ...data
  },
});

export const noop = () => ({
  type: NOOP,
});

export const signOut = () => ({
  type: SIGN_OUT,
});

export const fetchSession = () => ({
  type: FETCH_SESSION,
});

export const sessionLoadFailed = () => ({
  type: SESSION_LOAD_FAILED,
});
